import { render, staticRenderFns } from "./orderListDet.vue?vue&type=template&id=f3532ece&scoped=true"
import script from "./orderListDet.vue?vue&type=script&lang=js"
export * from "./orderListDet.vue?vue&type=script&lang=js"
import style0 from "./orderListDet.vue?vue&type=style&index=0&id=f3532ece&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3532ece",
  null
  
)

export default component.exports